import { render, staticRenderFns } from "./BadRequest.vue?vue&type=template&id=a6a890c0"
import script from "./BadRequest.vue?vue&type=script&lang=ts"
export * from "./BadRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports